import Model from 'src/storage/base';
import { openApp } from 'src/helpers';
import { formatFileReq } from 'src/components/user/components';

class SignupClinicModel extends Model {
  id = 'SignupClinicModel';

  apiConfig = {
    signupClinic: {
      url: 'clinic/auth/signup',
      validation: {
        name: 'name',
        email: 'emailAddress',
        username: 'username',
        password: 'password',
        phoneNumber: 'phoneNumber'
      },
      cancellable: true
    }
  };

  signUpClinic = (data = {}, cb, gid_token) => {
    let req = {
      name: data.name,
      email: data.email,
      username: data.username,
      phoneNumber: data.phoneNumber,
      password: data.password,
      gid_token
    };
    formatFileReq(req, data.avatar);
    this.api('signupClinic', req, (err, data, success) => {
      if (success) {
        openApp();
        cb(true);
        this.emit('auth', data);
      } else {
        cb(false);
      }
    });
  };
}

const model = new SignupClinicModel();
export default model;
